<div class="text-black text-lg font-semibold leading-tight">
    {{ userObj?.userEmail }}
</div>
